import { LAYOUT_FOOTER, LAYOUT_MAX_WIDTH, type LayoutWidth } from './tokens';

interface AppFooterProps {
  width?: LayoutWidth;
}

export function AppFooter({ width = 'default' }: AppFooterProps) {
  return (
    <footer className={LAYOUT_FOOTER}>
      <p className={`mx-auto text-center text-[11px] text-slate-600 sm:text-xs ${LAYOUT_MAX_WIDTH[width]} px-4`}>
        DS Espetos Grill © {new Date().getFullYear()} · Digital Signage
      </p>
    </footer>
  );
}
